import { Component, Input, OnInit } from '@angular/core';
import { IdService } from './id.service';

@Component({
  selector: 'app-id',
  templateUrl: './id.component.html',
  styleUrls: ['./id.component.css']
})
export class IdComponent implements OnInit {
  @Input() origemId: string | number;
  @Input() id: string | number;

  public alternarIdOrigem: string | number;
  public tooltipText: string;

  constructor(private idService: IdService) {}

  ngOnInit(): void {
    this.updateDisplay();
    this.idService.mostrarOrigemId$.subscribe(() => this.updateDisplay());
  }

  onDoubleClick(): void {
    this.idService.alterarVisualizacao();
  }

  private updateDisplay(): void {
    const mostrarOrigemId = this.idService.mostrarOrigemId;
    this.alternarIdOrigem = mostrarOrigemId
      ? this.origemId !== undefined ? this.origemId : 'Não informado'
      : this.id !== undefined ? this.id : 'Não informado';

    this.tooltipText = mostrarOrigemId
      ? `Id: ${this.id !== undefined ? this.id : 'Não informado'}`
      : `Origem Id: ${this.origemId !== undefined ? this.origemId : 'Não informado'}`;
  }
}
